import React from 'react';
import { connect } from 'react-redux';
import StyledFrame from './PcrVerified.frame';
import moment from 'moment';
import * as infoboxActions from '../../../../redux/actions/infobox.actions';

const PcrVerifiedContainer = props => {
  const isDisabled = () => {
    if (props.isUserAdmin) {
      return false;
    }

    if (!props.isPcrEnabled) {
      return true;
    }

    return props.isPcrVerified || !props.isRequestComplete;
  };

  return <StyledFrame {...props} isDisabled={isDisabled()} />;
};

function mapStateToProps(state) {
  return {
    pcrVerifiedAt:
      state.requests.pcrVerifiedAt && moment(state.requests.pcrVerifiedAt).isValid()
        ? moment(state.requests.pcrVerifiedAt).format('MM/DD')
        : '',
    pcrVerifiedBy: state.requests.pcrVerifiedBy,
    loadedRequest: state.formFlow.loadedRequest,
    isRequestComplete: state.requests.request.isCompleted,
    isUserAdmin: state.user.isUserAmbAdmin,
  };
}

export default connect(mapStateToProps, {
  ...infoboxActions,
})(PcrVerifiedContainer);
